import * as React from "react";
import { useListItem } from "@floating-ui/react";
import classnames from "classnames";
import { useDropdownContext } from "../../../../../context/ButtonDropdown/context/ButtonDropdownContext.js";
const ButtonDropdownEmptyOption = ({ className }) => {
  const {
    floatingProps: { getItemProps }
  } = useDropdownContext();
  const { ref } = useListItem();
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      ref,
      "data-spacer": true,
      "aria-disabled": true,
      "data-t": "button-dropdown__empty-option",
      className: classnames("button-dropdown__empty-option", className),
      ...getItemProps()
    }
  );
};
export {
  ButtonDropdownEmptyOption
};
//# sourceMappingURL=ButtonDropdownEmptyOption.js.map
